const NAVIGATION = {
  NAVIGATE_TO: 'NAVIGATE_TO',
  NAVIGATE_BACK: 'NAVIGATE_BACK',
  NAVIGATE_FORWARD: 'NAVIGATE_FORWARD',
  CLEAR_NAVIGATION: 'CLEAR_NAVIGATION',
};

export default NAVIGATION;
